import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
	Button,
} from '@windmill/react-ui';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import { SidebarContext } from 'context/SidebarContext';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import SoldOutServices from 'services/SoldOutServices';
import { FiPlus } from 'react-icons/fi';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import sidebar from 'routes/sidebar';
import SoldOutTable from 'components/vehicleCategory/SoldOutTable';
import SoldOutDrawer from 'components/drawer/SoldOutDrawer';

const SoldOut = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { toggleDrawer } = useContext(SidebarContext);
	const { title, serviceId } = useToggleDrawer();
	const [status, setStatus] = useState('');
	const { data, loading, error } = useAsync(SoldOutServices.getAllSoldOut);
	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'sold out' && perm.view === 1
		  );

	const hideDelete = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'sold out' && perm.delete === 1
		  );

	const hideEdit = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'sold out' && perm.edit === 1
		  );

	const hideAdd = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'sold out' && perm.add === 1
		  );

	const [itemsPerPage, setItemsPerPage] = useState(10);
	const { soldRef, dataTable, serviceData, handleSubmitSold, currentPage } =
		useFilter(Array.isArray(data.data) ? data.data : [], itemsPerPage);
	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);

	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);

	return (
		<>
			{hideView && (
				<>
					<DeleteModal id={serviceId} title={title} />

					<MainDrawer>
						<SoldOutDrawer id={serviceId} />
					</MainDrawer>

					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div className="flex gap-6 items-center">
								<div className="flex-1">
									<Input
										ref={soldRef}
										className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
										type="search"
										name="search"
										autoComplete="off"
										placeholder="Quick Search"
										onChange={handleSubmitSold}
									/>
								</div>

								{hideAdd && (
									<Button
										onClick={toggleDrawer}
										className="w-56 rounded-md h-10"
									>
										<span className="mr-3">
											<FiPlus />
										</span>
										Add sold
									</Button>
								)}
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer>
								<div
									className="overflow-y-scroll"
									style={{ maxHeight: '67vh', scrollbarWidth: 'thin' }}
								>
									<Table>
										<TableHeader className="capitalize text-center z-10 sticky top-0">
											<tr>
												<TableCell>Sl.No.</TableCell>
												<TableCell>City</TableCell>
												<TableCell>Package Type</TableCell>
												<TableCell>Vehicle Type</TableCell>
												<TableCell>Start Date</TableCell>
												<TableCell>End Date</TableCell>
												<TableCell>Actions</TableCell>
											</tr>
										</TableHeader>
										<SoldOutTable
											vehicleCategory={dataTable}
											perpage={itemsPerPage}
											currentPage={currentPage}
											hideEdit={hideEdit}
											hideDelete={hideDelete}
										/>
									</Table>
								</div>
							</TableContainer>
						) : (
							<>
								{data.status !== true ? (
									<Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
								) : (
									<NotFound title="There are no Sold Out." />
								)}
							</>
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default SoldOut;
